/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { organizationSchema } from "./organizationSchema.ts";
import { permissionSchema } from "./permissionSchema.ts";
import { z } from "zod";

export const organizationMemberListItemSchema = z.object({
      "id": z.string().optional(),
  "firstName": z.string().optional(),
  "lastName": z.string().optional(),
  "initials": z.string().optional(),
  "fonction": z.string().optional(),
  "organizationName": z.string().describe("Nom des organisations dont l'utilisateur est membre").optional(),
  "organizationId": z.string(),
  "organizations": z.array(z.lazy(() => organizationSchema)).describe("Liste des organisations dont l'utilisateur est membre").optional(),
  "memberType": z.enum(["ADMIN", "REGULAR", "INVITED"]),
  "invitationStatus": z.enum(["PENDING", "ACCEPTED"]).nullable().nullish(),
  "verified": z.boolean().optional(),
  "avatarUrl": z.string().url().nullable().nullish(),
  "email": z.string().email(),
  "permissions": z.array(z.lazy(() => permissionSchema)).describe("Features/permissions represented by icons").optional()
      })